import { Divider } from "primereact/divider";

import { panelLabelQuestion } from "_constants";
import { DetailRepliedAnswer } from "components/shared";

export const ReportQuestionContainer = ({
  question,
  repliedAnswer,
}: {
  question: string;
  repliedAnswer?: string;
}) => {
  return (
    <div className="question-container">
      <span className="blue-text font-weight-700 margin-bottom-8">
        {panelLabelQuestion}
      </span>
      {repliedAnswer && (
        <DetailRepliedAnswer
          repliedAnswer={repliedAnswer}
          className="padd-top-18 padd-bottom-18"
        />
      )}
      <div className="question-container-value margin-top-8">{question}</div>
      <Divider className="question-divider" />
    </div>
  );
};
